// Copyright © 2024 The Things Industries B.V.

// Alert Notification.

export const selectAlertNotificationStore = state => state.alertNotifications
export const selectAlertProfilesStore = state => selectAlertNotificationStore(state).profiles
export const selectAlertReceiversStore = state => selectAlertNotificationStore(state).receivers
